import { render, staticRenderFns } from "./bpTrends.vue?vue&type=template&id=3b012875&"
import script from "./bpTrends.vue?vue&type=script&lang=js&"
export * from "./bpTrends.vue?vue&type=script&lang=js&"
import style0 from "./bpTrends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports